import {PRICES_ADDRESS_ROOMS} from "../constants/prices_address_rooms";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {IRcnAddressKey} from "../types/IRcnAddress";
import {IRcnResolvedPoint} from "../utils/resolve_rcn_latest_point";
import {useRcnLatestStats} from "./use_rcn_latest_stats";

/** Newest point of each room count that publishes one, with its grain - sizes can resolve to different periods. */
export type AddressRoomsStats = Map<number, IRcnResolvedPoint>;

export const useAddressRoomsStats = (address: IRcnAddressKey, availableRooms: readonly RoomsFilter[]): AddressRoomsStats => {
    const getTarget = (rooms: number) => (availableRooms.includes(rooms) ? address : null);
    const [one, two, three, four, five] = PRICES_ADDRESS_ROOMS;

    const results = [
        [one, useRcnLatestStats(getTarget(one), one, "per_m2")],
        [two, useRcnLatestStats(getTarget(two), two, "per_m2")],
        [three, useRcnLatestStats(getTarget(three), three, "per_m2")],
        [four, useRcnLatestStats(getTarget(four), four, "per_m2")],
        [five, useRcnLatestStats(getTarget(five), five, "per_m2")]
    ] as const;

    const stats: AddressRoomsStats = new Map();

    for (const [rooms, {point, grain}] of results) {
        if (point && grain) {
            stats.set(rooms, {point, grain});
        }
    }

    return stats;
};
import {PRICES_ADDRESS_ROOMS} from "../constants/prices_address_rooms";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {IRcnAddressKey} from "../types/IRcnAddress";
import {IRcnResolvedPoint} from "../utils/resolve_rcn_latest_point";
import {useRcnLatestStats} from "./use_rcn_latest_stats";

/** Newest point of each room count that publishes one, with its grain - sizes can resolve to different periods. */
export type AddressRoomsStats = Map<number, IRcnResolvedPoint>;

export const useAddressRoomsStats = (address: IRcnAddressKey, availableRooms: readonly RoomsFilter[]): AddressRoomsStats => {
    const getTarget = (rooms: number) => (availableRooms.includes(rooms) ? address : null);
    const [one, two, three, four, five] = PRICES_ADDRESS_ROOMS;

    const results = [
        [one, useRcnLatestStats(getTarget(one), one, "per_m2")],
        [two, useRcnLatestStats(getTarget(two), two, "per_m2")],
        [three, useRcnLatestStats(getTarget(three), three, "per_m2")],
        [four, useRcnLatestStats(getTarget(four), four, "per_m2")],
        [five, useRcnLatestStats(getTarget(five), five, "per_m2")]
    ] as const;

    const stats: AddressRoomsStats = new Map();

    for (const [rooms, {point, grain}] of results) {
        if (point && grain) {
            stats.set(rooms, {point, grain});
        }
    }

    return stats;
};
